import React from "react";
import CarMasterData from "./carMasterData";

const TypesList = () => {
  const tabeName = "carSteering";

  return (
    <>
      <CarMasterData tabeName={tabeName} />
    </>
  );
};

export default TypesList;
